import { render, staticRenderFns } from "./SlickCarousel.vue?vue&type=template&id=70d35da7&scoped=true&"
import script from "./SlickCarousel.vue?vue&type=script&lang=js&"
export * from "./SlickCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SlickCarousel.vue?vue&type=style&index=0&id=70d35da7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d35da7",
  null
  
)

export default component.exports